import Print from "../components/print";

class Default {
  prints = [];

  beforeEnter(data) {
    const scope = data.next.container;
    window._footer.handleFooterClass(scope);
    this.handleActiveLinks(scope);
    this.initUnderline(scope);
    this.initFadeIn(scope);
    this.initPrint(scope);
    this.initLightbox(scope);
  }

  afterEnter(data) {
    this.runGA();
    this.refreshScrollTriggers();
    const cat = $(data.next.container).data("cat");
    window._header.handleActiveClass(cat);
  }

  beforeLeave(data) {
    window._header.closeFlyout();
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    window._hamburger.close();

    window._header.closeALlAccordions();

    this.destroyPrint();
  }

  afterLeave(data) {
    this.killScrollTriggers();
  }

  handleActiveLinks = (container) => {
    const cat = $(container).data("cat");
    const entry = $(container).data("entry");

    window._header.setActiveLink(cat, entry);
  };

  initUnderline = (scope) => {
    const $underline = $(scope).find(".underline");

    // init underlines
    if ($underline.length) {
      import("../components/underline").then(({ default: Underline }) => {
        // init underlines
        $underline.each((i, el) => {
          new Underline($(el));
        });
      });
    }
  };

  killScrollTriggers = () => {
    if (window._ScrollTrigger) {
      const allTrigger = window._ScrollTrigger.getAll();
      for (let i = 0; i < allTrigger.length; i++) {
        allTrigger[i].kill(true);
      }
    }
  };

  refreshScrollTriggers = () => {
    if (window._ScrollTrigger) {
      window._ScrollTrigger.refresh(true);
    }
  };

  initFadeIn = (scope) => {
    const $fadeIns = $(scope).find('[data-fade-in="el"]');

    if ($fadeIns.length) {
      import("../components/fade-in").then(({ default: FadeIn }) => {
        // init FadeIns
        $fadeIns.each((i, el) => {
          new FadeIn($(el));
        });
      });
    }
  };

  initPrint = (scope) => {
    const $prints = $(scope).find('[data-print="el"]');

    if ($prints.length) {
      // loop though all the print elements and initialize them
      $prints.each((index, el) => {
        const $el = $(el);
        const print = new Print($el);
        this.prints.push(print);
      });
    }
  };

  destroyPrint = () => {
    for (let i = 0; i < this.prints.length; i++) {
      this.prints[i].destroy();
    }
    this.prints = [];
  };

  initLightbox = (scope) => {
    const $lightbox = $(scope).find('[data-lightbox="trigger"]');

    if ($lightbox.length) {
      import("../components/lightbox").then(({ default: Lightbox }) => {
        // init lightbox
        $lightbox.each((i, el) => {
          new Lightbox($(el), $(scope));
        });
      });
    }
  };

  runGA = () => {
    if (typeof gtag === "function") {
      const path = window.location.href
        .replace(window.location.origin, "")
        .toLowerCase();
      gtag("js", new Date());
      gtag("config", "G-8N9ZBK8138", {
        page_title: document.title,
        page_path: path,
      });
    }
  };
}

export default Default;
